// extracted by mini-css-extract-plugin
module.exports = {"svg-wrapper":"svg-handler-m__svg-wrapper__3Sz7T","social-svg-wrapper":"svg-handler-m__social-svg-wrapper__1HLaD"};